import { Component, type OnDestroy, type OnInit, Input, ChangeDetectorRef } from '@angular/core'
import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { SharedService } from '../../../services/shared.service'
import { ResizeService, type SCREEN_SIZE, CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'

import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
import { FooterV2Component } from '../footer-v2/footer-v2.component'
@Component({
  selector: 'customer-portal-footer-container',
  standalone: true,
  templateUrl: './footer-container.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule,
    FooterV2Component
  ]
})
export class FooterContainerComponent implements OnInit, OnDestroy {
  @Input() aboutView = false
  public screenSize: SCREEN_SIZE

  hasNewFooter

  sub = {
    onResize: null
  }

  constructor (
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>,
    public resizeService: ResizeService,
    private readonly sharedService: SharedService,
    private readonly cdRef: ChangeDetectorRef
  ) {
    this.screenSize = this.resizeService.screenSize
    this.hasNewFooter = this.remoteConfigService.get('hasNewFooter')
  }

  ngOnInit (): void {
    this.sub.onResize = this.resizeService.onResize.subscribe(size => {
      this.screenSize = size
      this.cdRef.detectChanges()
    })
  }

  ngOnDestroy (): void {
    this.sharedService.unsubscribe(this.sub)
  }
}
